import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const Wrapper = styled.section`
  padding: ${cssTheme.layout.spacing.s500} 0;
  &.--has-show-more {
    padding-bottom: ${cssTheme.layout.spacing.s500};
  }
  ${linariaMq.desktopXs} {
    padding: ${cssTheme.layout.spacing.s600};
  }
`

const ItemHeading = styled(Text)`
  text-transform: lowercase;

  &::first-letter {
    text-transform: uppercase;
  }
`

const HeadingWrapper = styled.div`
  margin-bottom: ${cssTheme.layout.spacing.s500};
`

const Subtitle = styled(Text)`
  margin-top: ${cssTheme.layout.spacing.s200};

  text-transform: lowercase;
  &::first-letter {
    text-transform: capitalize;
  }
`

interface Props {
  /** The title to display above the children */
  title?: React.ReactNode
  /** The title to display below the title */
  subtitle?: React.ReactNode
  /** The icon to display next to the title */
  icon?: React.ReactNode
  /** The children of the wrapper - the filter component */
  children: React.ReactNode
  /** The data-id applied to the wrqpper */
  dataId?: string
  withDivider?: boolean
  hasShowMore?: boolean
}

export const FilterSection: React.FC<Props> = ({
  children,
  title,
  subtitle,
  icon,
  dataId,
  withDivider = true,
  hasShowMore = false
}) => {
  return (
    <>
      <Wrapper
        data-id={dataId}
        className={cx(hasShowMore && '--has-show-more')}
      >
        {title && (
          <HeadingWrapper>
            <Box display="flex" gap="s250" alignItems="center">
              {icon}
              <ItemHeading tag="h3" variant="titleL">
                {title}
              </ItemHeading>
            </Box>
            {subtitle && (
              <Subtitle variant="bodyS" colorPath="content.neutral.secondary">
                {subtitle}
              </Subtitle>
            )}
          </HeadingWrapper>
        )}
        {children}
      </Wrapper>
      {withDivider && (
        <Box
          padding="s000"
          desktopXs={{
            paddingLeft: 's500',
            paddingRight: 's500'
          }}
        >
          <Divider />
        </Box>
      )}
    </>
  )
}
